function isObject(val) {
    if (val === null) { return false; }
    return ( (typeof val === 'function') || (typeof val === 'object') );
}

function toOptions(array, valueKey = null, labelKey = null) {
	labelKey = labelKey || valueKey;
	return array.map(el => {
		let value = el;
		let label = el;
		if (el && isObject(el)) {
			value = el[valueKey];
			label = el[labelKey];
		}
		return { value, label };
	});
}

async function toBase64(file) {
	return await new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => resolve(reader.result);
		reader.onerror = error => reject(error);
	});
}

function findObj(array, valueKey = null, labelKey = null) {
	labelKey = labelKey || valueKey;

	let obj = null;
	if (isObject(array)) {
		obj = array.find(el => el[labelKey] == valueKey);
	} else {
		obj = array.find(el => el == valueKey);
	}

	return obj;
}

const camelToSnakeCase = str => str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);

export { isObject, findObj, toOptions, toBase64, camelToSnakeCase }